module.exports = __webpack_public_path__ + "img/chris-black.dd53400b.png";